var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAuto(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 41.3 41.3",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.9,24.2h-5.2l-.9,2.5h-2.8l4.7-13.2h3.1l4.7,13.2h-2.8l-.9-2.5ZM22.2,22.1l-1.9-5.5-1.9,5.5h3.8Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.7,15l1.5-.7-.8-1.3c-1.2-1.9-2.8-3.4-4.6-4.6-2.2-1.3-4.7-2-7.3-2s-3.1.3-4.6.8c-1.4.5-2.8,1.2-4,2.1-1.2.9-2.2,2-3.1,3.3-.6.9-1.1,1.8-1.5,2.8l-1-.3c.4-1.1,1-2.2,1.6-3.2.9-1.3,2-2.5,3.3-3.5,1.3-1,2.7-1.8,4.3-2.3,1.6-.6,3.3-.8,5-.8,5.3,0,10.3,2.8,13,7.4l.6,1.1,1-.5-.5,3.3-2.9-1.6Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7,36c-5.3,0-10.3-2.8-13-7.4l-.6-1.1-1,.5.5-3.3,2.9,1.6-1.5.7.8,1.3c1.2,1.8,2.8,3.4,4.6,4.6,2.2,1.3,4.7,2,7.3,2s3.1-.3,4.6-.8c1.4-.5,2.8-1.2,4-2.1,1.2-.9,2.2-2,3.1-3.3.6-.9,1.1-1.8,1.5-2.8l1,.3c-.4,1.1-1,2.2-1.6,3.2-.9,1.3-2,2.5-3.3,3.5-1.3,1-2.7,1.8-4.3,2.3-1.6.6-3.3.8-5,.8Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAuto);
export default __webpack_public_path__ + "static/media/Auto.534926204f6caa515b3484aea2f00911.svg";
export { ForwardRef as ReactComponent };